import { render } from "./Beta.vue?vue&type=template&id=2481ba90&scoped=true"
import script from "./Beta.vue?vue&type=script&lang=js"
export * from "./Beta.vue?vue&type=script&lang=js"

import "./Beta.vue?vue&type=style&index=0&id=2481ba90&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2481ba90"]])

export default __exports__